@if (state.loading().product) {
  <div class="mt-d">{{ 'app.lib.common.loading' | actrans }}...</div>
} @else if (state.error()) {
  <bt-alert nzType="error" [message]="state.error() || ''"></bt-alert>
} @else if (state.product()) {
  <div class="m-d-off">
    @if (!options.hidePeriodGuests) {
      <btlib-order-period-guests></btlib-order-period-guests>
    }

    @if (!options.hideAvailablePoolUnits) {
      <btlib-order-pool-units></btlib-order-pool-units>
    }

    @if (!options.hideAccessories) {
      <btlib-order-accessories></btlib-order-accessories>
    }

    <btlib-order-group-items></btlib-order-group-items>

    <btlib-order-package-items></btlib-order-package-items>

    <btlib-order-input-fields></btlib-order-input-fields>

    @if (!options.hideAmount) {
      <btlib-order-amount-summary></btlib-order-amount-summary>
    }

    @if (!options.hideButtons) {
      <div class="mt-d">
        <button
          nz-button
          nzType="primary"
          nzBlock
          [disabled]="!state.canSubmit()"
          (click)="addToCart()">
          {{ 'web.cart.add' | actrans }}
        </button>
      </div>
    }
  </div>
}
